import logoImg from '../assets/logo.png';
import React, { useState, useRef, useEffect } from 'react';
import './LoginScreen.css';

export default function LoginScreen({ onLogin, error, loading, isLocked, lockSecsLeft, attempts }) {
  const [password, setPassword] = useState('');
  const [showPw,   setShowPw]   = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (!isLocked) setTimeout(() => inputRef.current?.focus(), 100);
  }, [isLocked]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!password.trim() || isLocked || loading) return;
    onLogin(password);
  };

  const lockMins = Math.ceil(lockSecsLeft / 60);

  return (
    <div className="login-page">

      {/* Warning */}
      <div className="login-warning">
        <i className="ti ti-shield-exclamation" aria-hidden="true" />
        <div>
          <strong>Restricted Access — Authorised Employees Only</strong>
          <p>
            This system contains SWISO TECH confidential and proprietary information.
            Unauthorised access, use, or distribution is strictly prohibited and may result
            in disciplinary action and/or legal proceedings. All access attempts are logged.
            By proceeding, you confirm you are an authorised SWISO TECH employee.
          </p>
        </div>
      </div>

      {/* Card */}
      <div className="login-card">

        {/* Logo — white version on dark pill, works on any background */}
        <div className="login-logo-wrap">
          <img src={logoImg} alt="SWISO dev" className="login-logo" />
        </div>

        <div className="login-divider" />

        <div className="login-heading">
          <h1>Process Guide</h1>
          <p>Enter your access password to continue</p>
        </div>

        {/* Lockout */}
        {isLocked && (
          <div className="login-lockout">
            <i className="ti ti-lock" aria-hidden="true" />
            <div>
              <strong>Access temporarily locked</strong>
              <p>Too many failed attempts. Try again in <strong>{lockMins} minute{lockMins !== 1 ? 's' : ''}</strong> ({lockSecsLeft}s).</p>
            </div>
          </div>
        )}

        {/* Form */}
        <form className="login-form" onSubmit={handleSubmit} noValidate>
          <div className="login-field">
            <label htmlFor="pw-input">Access password</label>
            <div className={`login-input-wrap${error && !isLocked ? ' input-error' : ''}`}>
              <i className="ti ti-lock" style={{ fontSize: 16, color: 'var(--text-hint)', flexShrink: 0 }} aria-hidden="true" />
              <input
                id="pw-input"
                ref={inputRef}
                type={showPw ? 'text' : 'password'}
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Enter password"
                disabled={isLocked || loading}
                autoComplete="current-password"
                aria-describedby={error ? 'login-error' : undefined}
              />
              <button
                type="button"
                className="pw-toggle"
                onClick={() => setShowPw(v => !v)}
                tabIndex={-1}
                aria-label={showPw ? 'Hide password' : 'Show password'}
              >
                <i className={`ti ${showPw ? 'ti-eye-off' : 'ti-eye'}`} aria-hidden="true" />
              </button>
            </div>
          </div>

          {error && !isLocked && (
            <div className="login-error" id="login-error" role="alert">
              <i className="ti ti-alert-circle" style={{ fontSize: 13 }} aria-hidden="true" />
              {error}
            </div>
          )}

          {attempts > 0 && !isLocked && !error && (
            <div className="login-attempts">{attempts} failed attempt{attempts !== 1 ? 's' : ''}</div>
          )}

          <button type="submit" className="login-btn" disabled={!password.trim() || isLocked || loading}>
            {loading
              ? <><i className="ti ti-loader-2 spin" aria-hidden="true" /> Verifying...</>
              : <><i className="ti ti-arrow-right" aria-hidden="true" /> Sign in</>
            }
          </button>
        </form>

        {/* Footer */}
        <div className="login-footer">
          <img src={logoImg} alt="SWISO dev" className="login-footer-logo" />
          <span>Technology L.L.C. · Confidential · Internal Use Only</span>
        </div>
      </div>
    </div>
  );
}
